import { ReactNode } from 'react';
import { useAuth } from '@/hooks/auth.hook';
import { PageURLs } from '@/utils/navigate';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '@/redux/hooks';
import { watchProfileLoading } from '@/redux/slices/auth.slice';

type NonLoginGuardProps = {
  children: ReactNode;
};
export function NonLoginGuard({ children }: NonLoginGuardProps) {
  const { isLoggedIn } = useAuth();
  const loading = useAppSelector(watchProfileLoading);

  if (isLoggedIn && !loading) {
    return <Navigate to={PageURLs.ofUsersManagement()} />;
  }

  return <>{children}</>;
}
